<ul>
  @for (unitType of unitTypes; track unitType) {
    @let filteredUnits = eligibleUnits() | filterByUnitType: unitType;

    @if(filteredUnits.length > 0) {
      <li>
        <p>
          {{ unitType | unitTypeToText }}:
          <homey-regular-rent-range [advertisements]="filteredUnits" />
        </p>
      </li>
    }
  }
</ul>
